export const EPOCH_TIME = "1970-01-01T00:00:00Z";
